import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, Output, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/router';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as jwt_decode_imp from 'jwt-decode';
import * as i2$1 from 'devextreme-angular';
import { DxDataGridModule, DxTreeListModule, DxLookupModule, DxLoadPanelModule, DxButtonModule, DxTextBoxModule, DxNumberBoxModule, DxSwitchModule, DxCheckBoxModule, DxTabsModule, DxPopupModule, DxTextAreaModule, DxPopoverModule, DxSliderModule, DxRadioGroupModule, DxSelectBoxModule, DxFormModule, DxScrollViewModule, DxTagBoxModule, DxDateBoxModule, DxValidatorModule, DxLoadIndicatorModule, DxDropDownBoxModule, DxHtmlEditorModule, DxColorBoxModule, DxToastModule, DxTooltipModule, DxTemplateModule, DxFilterBuilderModule } from 'devextreme-angular';
import * as i3 from 'devextreme-angular/ui/nested';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from 'devextreme-angular/core';
import * as i6 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

class CloudLabsCoreService {
    constructor() { }
}
CloudLabsCoreService.ɵfac = function CloudLabsCoreService_Factory(t) { return new (t || CloudLabsCoreService)(); };
CloudLabsCoreService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CloudLabsCoreService, factory: CloudLabsCoreService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloudLabsCoreService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class CloudLabsCoreComponent {
    constructor() { }
    ngOnInit() {
    }
}
CloudLabsCoreComponent.ɵfac = function CloudLabsCoreComponent_Factory(t) { return new (t || CloudLabsCoreComponent)(); };
CloudLabsCoreComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CloudLabsCoreComponent, selectors: [["lib-cloud-labs-core"]], decls: 2, vars: 0, template: function CloudLabsCoreComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, " cloud-labs-core works! ");
        i0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloudLabsCoreComponent, [{
        type: Component,
        args: [{
                selector: 'lib-cloud-labs-core',
                template: `
    <p>
      cloud-labs-core works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

const jwt_decode = jwt_decode_imp;
class CloudLoginService {
    constructor(http, router) {
        this.http = http;
        this.router = router;
        this.remember = false;
        this.apiKey = "e5788b40-ec7e-0fe0-daf8-80c17445ab9d!?@f8a4!e347**11d3"; // cloudie
        this.loginApiUrl = "https://sso-service.kerzz.com:4500/api/user/login";
        this.lostPasswordUrl = "https://sso-service.kerzz.com:4500/api/user/resetpwd";
        this.authStatus = false;
        let rm = localStorage.getItem("remember");
        if (this.isJson(rm)) {
            this.remember = JSON.parse(rm).value;
        }
        else {
            this.remember = false;
        }
    }
    autoLogin() {
        let p = 2;
        let cred = localStorage.getItem("credentials");
        if (this.isJson(cred)) {
            let credentials = JSON.parse(cred);
            if (credentials) {
                console.log("credentials found, auto login", credentials);
                return this.login(credentials.email, credentials.password);
            }
            else {
                return new Promise((resolve, reject) => {
                    console.log("credentials not found, auto login disabled");
                    resolve("not-remember");
                });
            }
        }
        else {
            return new Promise((resolve, reject) => {
                console.log("credentials not found, auto login disabled");
                resolve("not-remember");
            });
        }
    }
    login(email, password) {
        return new Promise((resolve, reject) => {
            let httpOptions = {
                headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'apiKey': this.apiKey })
            };
            this.http.post(this.loginApiUrl, { email: email, password: password }, httpOptions).subscribe(o => {
                let activeLicance = localStorage.getItem("active-licance");
                this.userInfo = jwt_decode(Object.assign(o).token).userInfo;
                this.userInfo.licances.map(el => {
                    el.active = activeLicance == el.licanceId ? true : false;
                });
                this.acessToken = jwt_decode(Object.assign(o).token).userInfo.accessToken;
                this.name = this.userInfo.name;
                this.email = this.userInfo.mail;
                this.authStatus = true;
                console.log("userInfo", this.userInfo);
                let credentials = undefined;
                if (this.remember) {
                    credentials = JSON.stringify({ email: email, password: password });
                }
                localStorage.setItem("credentials", credentials);
                resolve("ok");
            }, e => {
                this.authStatus = false;
                reject(this.parseError(e));
            });
        });
    }
    setRemember(value) {
        localStorage.setItem("remember", JSON.stringify({ value: value }));
        this.remember = value;
    }
    setActiveLicance(licanceID) {
        this.userInfo.licances.map(o => {
            o.active = false;
        });
        this.userInfo.licances.find(o => o.licanceId == licanceID).active = true;
        localStorage.setItem("active-licance", licanceID);
    }
    getActiveLicance() {
        if (this.userInfo) {
            return this.userInfo.licances.find(o => o.active);
        }
        else {
            return undefined;
        }
    }
    logout() {
        localStorage.setItem("credentials", undefined);
        this.authStatus = false;
        this.router.navigate(['']);
        this.setRemember(false);
    }
    lostPassword(mail) {
        return new Promise((resolve, reject) => {
            let httpOptions = {
                headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'apiKey': this.apiKey })
            };
            this.http.post(this.lostPasswordUrl, { email: mail }, httpOptions).subscribe(o => {
                resolve("ok");
            }, e => {
                reject(this.parseError(e));
            });
        });
    }
    isJson(item) {
        item = typeof item !== "string"
            ? JSON.stringify(item)
            : item;
        try {
            item = JSON.parse(item);
        }
        catch (e) {
            return false;
        }
        if (typeof item === "object" && item !== null) {
            return true;
        }
        return false;
    }
    parseError(e) {
        if (e.error.message) {
            return e.error.message;
        }
        else {
            console.log(e);
            return "Server Error";
        }
    }
}
CloudLoginService.ɵfac = function CloudLoginService_Factory(t) { return new (t || CloudLoginService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Router)); };
CloudLoginService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CloudLoginService, factory: CloudLoginService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloudLoginService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.Router }]; }, null); })();

function CloudLoginWebComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "i", 20);
    i0.ɵɵtext(2, "error");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r2.error, " ");
} }
function CloudLoginWebComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "dx-load-indicator", 21);
    i0.ɵɵelementStart(2, "span", 22);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visible", ctx_r4.loadIndicatorVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "Login"));
} }
function CloudLoginWebComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "dx-load-indicator", 21);
    i0.ɵɵelementStart(2, "span", 22);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visible", ctx_r5.lostPasswordIndicator);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "Reset Password"));
} }
class CloudLoginWebComponent {
    constructor(ls) {
        this.ls = ls;
        this.loginStatus = new EventEmitter();
        this.status = "login";
        this.loadIndicatorVisible = false;
        this.lostPasswordIndicator = false;
    }
    ngOnInit() {
        this.ls.apiKey = this.apikey;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.autoLogin();
        }, 1);
    }
    autoLogin() {
        debugger;
        this.loadIndicatorVisible = true;
        this.ls.autoLogin().then(o => {
            this.loadIndicatorVisible = false;
            if (o == "ok") {
                this.loginStatus.emit({ status: login_enum.loggedin, message: "" });
            }
        }, e => {
            this.loginStatus.emit({ status: login_enum.loggedout, message: e });
            this.error = e;
            this.error = this.error.toLocaleUpperCase();
            this.loadIndicatorVisible = false;
        });
    }
    login(e) {
        debugger;
        e.preventDefault();
        this.error = undefined;
        this.loadIndicatorVisible = true;
        this.ls.login(this.user, this.pass).then(o => {
            this.loadIndicatorVisible = false;
            this.loginStatus.emit({ status: login_enum.loggedin, message: "" });
        }, error => {
            this.loginStatus.emit({ status: login_enum.loggedout, message: error });
            this.loadIndicatorVisible = false;
            this.error = error;
            this.error = this.error.toLocaleUpperCase();
        });
    }
    lostPassword() {
        this.lostPasswordIndicator = true;
        this.ls.lostPassword(this.user).then(o => {
            this.lostPasswordIndicator = false;
            this.error = "Şifre sıfırlama epostanız gönderildi.";
        }, e => {
            this.error = e;
            this.error = this.error.toLocaleUpperCase();
            this.lostPasswordIndicator = false;
        });
    }
}
CloudLoginWebComponent.ɵfac = function CloudLoginWebComponent_Factory(t) { return new (t || CloudLoginWebComponent)(i0.ɵɵdirectiveInject(CloudLoginService)); };
CloudLoginWebComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CloudLoginWebComponent, selectors: [["lib-cloud-login-web"]], inputs: { apikey: "apikey" }, outputs: { loginStatus: "loginStatus" }, decls: 37, vars: 42, consts: [[1, "cloudie-login-box"], [1, "header"], [3, "submit"], [1, "content"], [1, "field"], [3, "stylingMode", "placeholder", "value", "showClearButton", "valueChange"], ["username1", ""], ["type", "required", 3, "message"], ["type", "email", 3, "message"], ["mode", "password", 3, "stylingMode", "placeholder", "value", "showClearButton", "valueChange"], ["password1", ""], ["class", "error", 4, "ngIf"], [1, "remember-me"], [3, "value", "valueChange"], ["remember", ""], [1, "buttons"], ["type", "success", "useSubmitBehavior", "true", 3, "width", "text", "disabled"], [4, "dxTemplate", "dxTemplateOf"], ["type", "danger", 3, "stylingMode", "width", "text", "disabled", "onClick"], [1, "error"], [1, "material-icons-outlined", "md-18", 2, "padding-right", "4px"], [1, "button-indicator", 3, "visible"], [1, "dx-button-text"]], template: function CloudLoginWebComponent_Template(rf, ctx) { if (rf & 1) {
        const _r8 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "form", 2);
        i0.ɵɵlistener("submit", function CloudLoginWebComponent_Template_form_submit_4_listener($event) { return ctx.login($event); });
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "dx-text-box", 5, 6);
        i0.ɵɵlistener("valueChange", function CloudLoginWebComponent_Template_dx_text_box_valueChange_7_listener($event) { return ctx.user = $event; });
        i0.ɵɵpipe(9, "translate");
        i0.ɵɵelementStart(10, "dx-validator");
        i0.ɵɵelement(11, "dxi-validation-rule", 7);
        i0.ɵɵpipe(12, "translate");
        i0.ɵɵelement(13, "dxi-validation-rule", 8);
        i0.ɵɵpipe(14, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 4);
        i0.ɵɵelementStart(16, "dx-text-box", 9, 10);
        i0.ɵɵlistener("valueChange", function CloudLoginWebComponent_Template_dx_text_box_valueChange_16_listener($event) { return ctx.pass = $event; });
        i0.ɵɵpipe(18, "translate");
        i0.ɵɵelementStart(19, "dx-validator");
        i0.ɵɵelement(20, "dxi-validation-rule", 7);
        i0.ɵɵpipe(21, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(22, CloudLoginWebComponent_div_22_Template, 4, 1, "div", 11);
        i0.ɵɵelementStart(23, "div", 12);
        i0.ɵɵelementStart(24, "span");
        i0.ɵɵtext(25);
        i0.ɵɵpipe(26, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(27, "\u00A0 ");
        i0.ɵɵelementStart(28, "dx-switch", 13, 14);
        i0.ɵɵlistener("valueChange", function CloudLoginWebComponent_Template_dx_switch_valueChange_28_listener() { i0.ɵɵrestoreView(_r8); const _r3 = i0.ɵɵreference(29); return ctx.ls.setRemember(_r3.value); })("valueChange", function CloudLoginWebComponent_Template_dx_switch_valueChange_28_listener($event) { return ctx.ls.remember = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 15);
        i0.ɵɵelementStart(31, "dx-button", 16);
        i0.ɵɵpipe(32, "translate");
        i0.ɵɵtemplate(33, CloudLoginWebComponent_div_33_Template, 5, 4, "div", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "dx-button", 18);
        i0.ɵɵlistener("onClick", function CloudLoginWebComponent_Template_dx_button_onClick_34_listener() { return ctx.lostPassword(); });
        i0.ɵɵpipe(35, "translate");
        i0.ɵɵtemplate(36, CloudLoginWebComponent_div_36_Template, 5, 4, "div", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 24, "Login"), " ");
        i0.ɵɵadvance(5);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(9, 26, "User name"));
        i0.ɵɵproperty("stylingMode", "filled")("value", ctx.user)("showClearButton", true);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("message", i0.ɵɵpipeBind1(12, 28, "User name Required"));
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("message", i0.ɵɵpipeBind1(14, 30, "Invalid Email Address"));
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 32, "Password"));
        i0.ɵɵproperty("stylingMode", "outlined")("value", ctx.pass)("showClearButton", true);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("message", i0.ɵɵpipeBind1(21, 34, "Password Required"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.error != undefined);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 36, "Remember Me!"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("value", ctx.ls.remember);
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("text", i0.ɵɵpipeBind1(32, 38, "Login"));
        i0.ɵɵproperty("width", 100)("disabled", ctx.loadIndicatorVisible);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dxTemplateOf", "content");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("text", i0.ɵɵpipeBind1(35, 40, "Lost Password"));
        i0.ɵɵproperty("stylingMode", "text")("width", 190)("disabled", ctx.loadIndicatorVisible);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dxTemplateOf", "content");
    } }, directives: [i2$1.DxTextBoxComponent, i2$1.DxValidatorComponent, i3.DxiValidationRuleComponent, i4.NgIf, i2$1.DxSwitchComponent, i2$1.DxButtonComponent, i5.DxTemplateDirective, i2$1.DxLoadIndicatorComponent], pipes: [i6.TranslatePipe], styles: ["body[_ngcontent-%COMP%]{background-color:var(--workspace-background);color:var(--workspace-text)}.cloudie-login-box[_ngcontent-%COMP%]{min-width:300px;min-height:210px}.header[_ngcontent-%COMP%]{width:100%;height:40px;text-align:center;vertical-align:middle;font-family:\"Montserrat\",sans-serif;font-size:1.2em;font-weight:bold;line-height:normal;align-items:center}.label[_ngcontent-%COMP%]{display:inline-block;width:100px;padding:5px}.field[_ngcontent-%COMP%]{display:flex;flex-flow:column-reverse;margin-bottom:1em}.error[_ngcontent-%COMP%]{font-family:\"Montserrat\",sans-serif;font-size:14px;color:#ff0;align-items:center;display:flex;justify-content:center}label[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{font-family:\"Montserrat\",sans-serif;transition:all .2s;touch-action:manipulation}input[_ngcontent-%COMP%]{font-family:\"Montserrat\",sans-serif;font-size:16px;border:0;border-bottom:1px solid #ccc;font-family:inherit;-webkit-appearance:none;border-radius:0;padding:0;cursor:text}input[_ngcontent-%COMP%]:focus{outline:0;border-bottom:1px solid #666}label[_ngcontent-%COMP%]{text-transform:uppercase;letter-spacing:.05em}[_ngcontent-%COMP%]::-webkit-input-placeholder{opacity:0;-webkit-transition:inherit;transition:inherit}input[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{opacity:1}button[_ngcontent-%COMP%]{border:1px solid grey;background-color:#4682b4;font-family:\"Montserrat\",sans-serif;color:#fff;width:150px;height:30px;float:right}@media screen and (max-width: 600px){.login-box[_ngcontent-%COMP%]{width:70%;height:500px;position:fixed;top:20%;left:20%}}.button-indicator[_ngcontent-%COMP%]{height:20px;width:20px;display:inline-block;vertical-align:middle;margin-right:5px}.remember-me[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-end;font-family:\"Montserrat\",sans-serif;font-size:12px;margin-bottom:15px;align-items:center}.buttons[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloudLoginWebComponent, [{
        type: Component,
        args: [{
                selector: 'lib-cloud-login-web',
                templateUrl: './cloud-login-web.component.html',
                styleUrls: ['./cloud-login-web.component.css']
            }]
    }], function () { return [{ type: CloudLoginService }]; }, { loginStatus: [{
            type: Output
        }], apikey: [{
            type: Input
        }] }); })();
var login_enum;
(function (login_enum) {
    login_enum[login_enum["loggedin"] = 0] = "loggedin";
    login_enum[login_enum["loggedout"] = 1] = "loggedout";
})(login_enum || (login_enum = {}));

class CloudLabsCoreModule {
}
CloudLabsCoreModule.ɵfac = function CloudLabsCoreModule_Factory(t) { return new (t || CloudLabsCoreModule)(); };
CloudLabsCoreModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CloudLabsCoreModule });
CloudLabsCoreModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TranslateModule,
            DxDataGridModule,
            DxTreeListModule,
            DxLookupModule,
            DxLoadPanelModule,
            DxButtonModule,
            DxTextBoxModule,
            DxNumberBoxModule,
            DxSwitchModule,
            DxCheckBoxModule,
            DxTabsModule,
            DxPopupModule,
            DxTextAreaModule,
            DxPopoverModule,
            DxSliderModule,
            DxRadioGroupModule,
            DxSelectBoxModule,
            DxFormModule,
            DxScrollViewModule,
            DxTagBoxModule,
            DxDateBoxModule,
            DxValidatorModule,
            DxLoadIndicatorModule,
            DxSwitchModule,
            DxDropDownBoxModule,
            DxHtmlEditorModule,
            DxColorBoxModule,
            DxToastModule,
            DxTooltipModule,
            DxTemplateModule,
            DxFilterBuilderModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloudLabsCoreModule, [{
        type: NgModule,
        args: [{
                declarations: [CloudLabsCoreComponent, CloudLoginWebComponent],
                imports: [
                    CommonModule,
                    TranslateModule,
                    DxDataGridModule,
                    DxTreeListModule,
                    DxLookupModule,
                    DxLoadPanelModule,
                    DxButtonModule,
                    DxTextBoxModule,
                    DxNumberBoxModule,
                    DxSwitchModule,
                    DxCheckBoxModule,
                    DxTabsModule,
                    DxPopupModule,
                    DxTextAreaModule,
                    DxPopoverModule,
                    DxSliderModule,
                    DxRadioGroupModule,
                    DxSelectBoxModule,
                    DxFormModule,
                    DxScrollViewModule,
                    DxTagBoxModule,
                    DxDateBoxModule,
                    DxValidatorModule,
                    DxLoadIndicatorModule,
                    DxSwitchModule,
                    DxDropDownBoxModule,
                    DxHtmlEditorModule,
                    DxColorBoxModule,
                    DxToastModule,
                    DxTooltipModule,
                    DxTemplateModule,
                    DxFilterBuilderModule,
                ],
                exports: [CloudLabsCoreComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CloudLabsCoreModule, { declarations: [CloudLabsCoreComponent, CloudLoginWebComponent], imports: [CommonModule,
        TranslateModule,
        DxDataGridModule,
        DxTreeListModule,
        DxLookupModule,
        DxLoadPanelModule,
        DxButtonModule,
        DxTextBoxModule,
        DxNumberBoxModule,
        DxSwitchModule,
        DxCheckBoxModule,
        DxTabsModule,
        DxPopupModule,
        DxTextAreaModule,
        DxPopoverModule,
        DxSliderModule,
        DxRadioGroupModule,
        DxSelectBoxModule,
        DxFormModule,
        DxScrollViewModule,
        DxTagBoxModule,
        DxDateBoxModule,
        DxValidatorModule,
        DxLoadIndicatorModule,
        DxSwitchModule,
        DxDropDownBoxModule,
        DxHtmlEditorModule,
        DxColorBoxModule,
        DxToastModule,
        DxTooltipModule,
        DxTemplateModule,
        DxFilterBuilderModule], exports: [CloudLabsCoreComponent] }); })();

class IdGeneratorService {
    constructor() {
        this.ids = [];
    }
    generateMaxi() {
        let isUnique = false;
        let tempId = '';
        while (!isUnique) {
            tempId = this.generator();
            if (!this.idExists(tempId)) {
                isUnique = true;
                this.ids.push(tempId);
            }
        }
        return tempId;
    }
    generate() {
        let isUnique = false;
        let tempId = '';
        while (!isUnique) {
            tempId = this.generator_mini();
            if (!this.idExists(tempId)) {
                isUnique = true;
                this.ids.push(tempId);
            }
        }
        return tempId;
    }
    remove(id) {
        const index = this.ids.indexOf(id);
        this.ids.splice(index, 1);
    }
    generator() {
        const isString = `${this.S4()}${this.S4()}-${this.S4()}-${this.S4()}-${this.S4()}-${this.S4()}${this.S4()}${this.S4()}!?@${this.S4()}!${this.S4()}**${this.S4()}`;
        return isString;
    }
    generator_mini() {
        const isString = `${this.S4()}-${this.S4()}`;
        return isString;
    }
    idExists(id) {
        return this.ids.includes(id);
    }
    S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
}
IdGeneratorService.ɵfac = function IdGeneratorService_Factory(t) { return new (t || IdGeneratorService)(); };
IdGeneratorService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IdGeneratorService, factory: IdGeneratorService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IdGeneratorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class CloudDbService {
    constructor(http, ig, ls) {
        this.http = http;
        this.ig = ig;
        this.ls = ls;
        this.accessToken = "token";
        this.postMongoUrl = "https://api.kerzz.com:5000/api/data/action";
    }
    init(db) {
        this.activeDb = db;
    }
    getCollection(prm) {
        let filter = prm._filter ? prm._filter : {};
        return this.http.post(this.postMongoUrl, {
            job: "get",
            database: this.getDb(prm._db),
            collection: prm.col,
            filter: filter,
            projection: prm._project,
            limit: prm._limit,
            skip: prm._skip,
            sort: prm._sort,
            withTotalCount: prm._withTotalCount
        }, this.getHeaders());
    }
    getCollectionToPromise(prm) {
        let filter = prm._filter ? prm._filter : {};
        return this.http.post(this.postMongoUrl, {
            job: "get",
            database: this.getDb(prm._db),
            collection: prm.col,
            filter: filter,
            projection: prm._project,
            limit: prm._limit,
            skip: prm._skip,
            sort: prm._sort,
            withTotalCount: prm._withTotalCount
        }, this.getHeaders()).toPromise();
    }
    upsert(prm) {
        if (!prm.data.id) {
            prm.data.id = this.ig.generate();
        }
        let filter = { id: prm.data.id };
        return this.http.post(this.postMongoUrl, {
            job: "upsert",
            database: this.getDb(prm._db),
            collection: prm.col,
            filter: filter,
            data: prm.data
        }, this.getHeaders()).toPromise();
    }
    delete(prm) {
        return this.http.post(this.postMongoUrl, {
            job: "delete",
            database: this.getDb(prm._db),
            collection: prm.col,
            filter: prm.filter
        }, this.getHeaders()).toPromise();
    }
    getHeaders() {
        let httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'authorization': this.accessToken })
        };
        return httpOptions;
    }
    getDb(db) {
        if (db) {
            return db;
        }
        else {
            if (this.ls && this.ls.getActiveLicance()) {
                return this.ls.getActiveLicance().licanceId;
            }
            else {
                return db;
            }
        }
    }
}
CloudDbService.ɵfac = function CloudDbService_Factory(t) { return new (t || CloudDbService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(IdGeneratorService), i0.ɵɵinject(CloudLoginService)); };
CloudDbService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CloudDbService, factory: CloudDbService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloudDbService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: IdGeneratorService }, { type: CloudLoginService }]; }, null); })();

/*
 * Public API Surface of cloud-labs-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CloudDbService, CloudLabsCoreComponent, CloudLabsCoreModule, CloudLabsCoreService, CloudLoginService, CloudLoginWebComponent, IdGeneratorService };
